import { keys } from '@servicetitan/cp-ui';
import { createPath } from 'history';
import { generatePath } from 'react-router-dom';

export const generatePathWithQuery = (
    path: string,
    queryParams: Record<string, string | string[] | number | number[]>,
    urlParams?: any
) => {
    const sp = new URLSearchParams();

    for (const param of keys(queryParams)) {
        const val = queryParams[param];

        if (val === undefined) {
            continue;
        }

        if (Array.isArray(val)) {
            val.forEach(v => sp.append(param, v as string));
        } else {
            sp.set(param, val as string);
        }
    }

    return createPath({
        pathname: generatePath(path, urlParams),
        search: Array.from(sp.keys()).length ? '?' + sp.toString() : undefined,
    });
};
